(function(){
  var KEY = 'bkCloudRewardsV1';

  function parse(raw, fallback){
    try {
      return raw ? JSON.parse(raw) : fallback;
    } catch(e){
      return fallback;
    }
  }

  function unique(list){
    return Array.from(new Set((list || []).filter(Boolean)));
  }

  function read(){
    var data = parse(localStorage.getItem(KEY), {});

    return {
      coins: Number(data.coins || 0),
      stickers: unique(data.stickers),
      badges: unique(data.badges),
      stamps: unique(data.stamps),
      history: Array.isArray(data.history) ? data.history.slice(-40) : []
    };
  }

  function write(data){
    data.coins = Math.max(0, Number(data.coins || 0));
    data.stickers = unique(data.stickers);
    data.badges = unique(data.badges);
    data.stamps = unique(data.stamps);
    data.history = Array.isArray(data.history) ? data.history.slice(-40) : [];

    localStorage.setItem(KEY, JSON.stringify(data));

    window.dispatchEvent(new CustomEvent('bk:rewards:update', {
      detail: data
    }));

    return data;
  }

  function award(reward){
    var data = read();

    reward = reward || {};

    data.coins += Number(reward.coins || 0);

    if(reward.sticker) {
      data.stickers.push(reward.sticker);
    }

    if(reward.badge) {
      data.badges.push(reward.badge);
    }

    if(reward.stamp) {
      data.stamps.push(reward.stamp);
    }

    data.stickers = unique(data.stickers);
    data.badges = unique(data.badges);
    data.stamps = unique(data.stamps);

    data.history.push({
      at: Date.now(),
      reward: reward
    });

    return write(data);
  }

  function reset(){
    localStorage.removeItem(KEY);

    window.dispatchEvent(new CustomEvent('bk:rewards:update', {
      detail: read()
    }));
  }

  window.BKCloudRewardsV1 = {
    key: KEY,
    read: read,
    write: write,
    award: award,
    reset: reset
  };
})();